/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserPlatformAccess} from '../models/UserPlatformAccess';

export interface GetAccountPlatformAccess$Request {
    accountId: number;
}

export interface GetAccountPlatformAccess$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountPlatformAccessRequest = createAction<PayloadData<void, GetAccountPlatformAccess$Request>>('GET_ACCOUNT_PLATFORM_ACCESS__GET_ACCOUNT_PLATFORM_ACCESS__REQUEST');
export const getAccountPlatformAccessSuccess = createAction<PayloadData<Array<UserPlatformAccess>, GetAccountPlatformAccess$Request>>('GET_ACCOUNT_PLATFORM_ACCESS__GET_ACCOUNT_PLATFORM_ACCESS__SUCCESS');
export const getAccountPlatformAccessFailure = createAction<PayloadData<Error, GetAccountPlatformAccess$Request, true>>('GET_ACCOUNT_PLATFORM_ACCESS__GET_ACCOUNT_PLATFORM_ACCESS__FAILURE');

export const getAccountPlatformAccessActions = [
    getAccountPlatformAccessRequest,
    getAccountPlatformAccessSuccess,
    getAccountPlatformAccessFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountPlatformAccess = (meta: GetAccountPlatformAccess$Request, config?: GetAccountPlatformAccess$Config) => {
    return {
        CALL_API: {
            types: getAccountPlatformAccessActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/users/platform-access`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

